<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Cancel reasons') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <button
              type="button"
              class="btn btn-dark mr-2"
              v-if="selected.length >= 2"
              @click="mergeTags()">
              {{ $tc('merge_n_items', selected.length, { count: selected.length }) }}
              </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('New') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1 p-3">

      <creating
        v-if="creating"
        height="100%" />

      <div
        class="shurt-conatiner"
        v-if="!creating"
        :class="{'box-loading': loading}">

        <div
          v-if="cancelReasons.length"
          class="list-group">
          <a
            v-for="(item, index) in cancelReasons"
            :key="index"
            href="javascript:void(0)"
            @click="showEditModal(item)"
            class="list-group-item list-group-item-action">
            <input
              class="m-0 mr-1"
              type="checkbox"
              @click.stop=""
              :value="item._id"
              v-model="selected">
              {{ item.name }}
            </a>
        </div>

        <no-results 
          v-if="!cancelReasons.length">
          {{ $t('There are no items') }}
        </no-results>

      </div>
    </div>

   <div
      v-if="modal_select"
      class="vflex-row-0">
      <cancel-reason-form 
        :initCancelReason="modal_select" 
        @hideModal="hideModal()" 
        @deleted="loadData(); hideModal()" 
        @saved="loadData(); hideModal()" 
        ></cancel-reason-form>
   </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import CancelReasonForm from './CancelReasonForm'

export default {
  name: 'CancelReason',
  components: {
    CancelReasonForm,
    InputKeyword
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      selected: []
    }
  },
  computed: {
    cancelReasons () {
      return this.$store.getters.getCancelReasons
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      let params = {
        sort: 'name',
        limit: 1000
      }

      this.$store
      .dispatch('selectCancelReasons', params)
      .then((result) => {
        this.loading = this.creating = false
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    mergeTags
    */
    mergeTags () {
      const mergeAction = () => {
        this.loading = true

        this.$store
        .dispatch('mergeCancelReasons', {cancelReasons: this.selected})
        .then((result) => {
          this.selected = []
          this.loadData(1)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: mergeAction,
        title: 'Deseja realmente unir esses registros?'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CancelReason/CancelReason.vue